<template>
  <div class="d-flex align-center ga-1">
    <v-chip color="grey-darken-1" variant="outlined" size="x-small" class="bg-white">
      {{ $t('condition.' + condition) }}
    </v-chip>
    <sf-info-tooltip v-if="grading">
      <template v-if="grading">
        <div>
          <b>{{ $t('conditionTooltip.conditionLabel') }}: {{ gradingLabel }}</b>
        </div>
        <div v-if="grading.text">{{ grading.text }}</div>
        <div v-if="grading.warrantyMonths > 0">
          <b>{{ grading.warrantyMonths }} {{ $t('conditionTooltip.monthsWarranty') }}</b>
        </div>
      </template>
    </sf-info-tooltip>
  </div>
</template>

<script setup lang="ts">
import SfInfoTooltip from '@/components/tooltip/SfInfoTooltip.vue'
import { Condition, Grading } from '@/types/index'
import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  condition: {
    type: String as PropType<Condition>,
    required: true
  },
  grading: {
    type: Object as PropType<Grading>,
    default: undefined
  }
})

const { t } = useI18n()

const gradingLabel = computed(() => {
  const code = props.grading?.code

  switch (code) {
    case 'A':
    case 'B':
    case 'C':
    case 'D':
      return t(`grading.${code}`)
    default:
      return code ?? ''
  }
})
</script>
